import { NotificationInstance } from "antd/es/notification/interface";
import React from "react";

export const NotiContext = React.createContext({} as NotificationInstance);
export const ModalContext = React.createContext({} as any);
